var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNounPower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun-power-5630433",
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.488,
    height: 86.075,
    viewBox: "0 0 54.488 86.075",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6447",
    "data-name": "Path 6447",
    d: "M15.36,51.641H33.609l-6.547,30.6a3.1,3.1,0,0,0,1.792,3.543,3.237,3.237,0,0,0,1.33.287,3.1,3.1,0,0,0,2.51-1.3l31.95-43.4a4.358,4.358,0,0,0-3.5-6.945H42.892l6.547-30.6A3.1,3.1,0,0,0,47.653.29a3.093,3.093,0,0,0-3.84,1L11.857,44.7a4.359,4.359,0,0,0,3.5,6.945Zm-1.2-5.244L46.124,3a.258.258,0,0,1,.209-.125.344.344,0,0,1,.143.034.255.255,0,0,1,.166.326l-6.928,32.33a1.434,1.434,0,0,0,1.4,1.736H61.141a1.489,1.489,0,0,1,1.2,2.375l-31.96,43.4a.25.25,0,0,1-.351.092.255.255,0,0,1-.166-.326h0l6.925-32.331a1.434,1.434,0,0,0-1.4-1.736H15.36a1.489,1.489,0,0,1-1.2-2.375Z",
    transform: "translate(-11.007 0.006)",
    fill: "#f7edd6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounPower);
export default __webpack_public_path__ + "static/media/noun-power.b0ffb0a81329ba7761dde3ffbbfa5c99.svg";
export { ForwardRef as ReactComponent };